/* tslint:disable */
/* eslint-disable */
/**
 * Marco Search API
 * Marco Search API
 *
 * The version of the OpenAPI document: 2.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PreBookResponseStatus } from './PreBookResponseStatus';
import {
    PreBookResponseStatusFromJSON,
    PreBookResponseStatusFromJSONTyped,
    PreBookResponseStatusToJSON,
    PreBookResponseStatusToJSONTyped,
} from './PreBookResponseStatus';

/**
 * A message returned from pre-booking validation
 * @export
 * @interface PreBookResponseMessage
 */
export interface PreBookResponseMessage {
    /**
     * 
     * @type {PreBookResponseStatus}
     * @memberof PreBookResponseMessage
     */
    status: PreBookResponseStatus;
    /**
     * 
     * @type {string}
     * @memberof PreBookResponseMessage
     */
    message: string;
}



/**
 * Check if a given object implements the PreBookResponseMessage interface.
 */
export function instanceOfPreBookResponseMessage(value: object): value is PreBookResponseMessage {
    if (!('status' in value) || value['status'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function PreBookResponseMessageFromJSON(json: any): PreBookResponseMessage {
    return PreBookResponseMessageFromJSONTyped(json, false);
}

export function PreBookResponseMessageFromJSONTyped(json: any, ignoreDiscriminator: boolean): PreBookResponseMessage {
    if (json == null) {
        return json;
    }
    return {
        
        'status': PreBookResponseStatusFromJSON(json['status']),
        'message': json['message'],
    };
}

export function PreBookResponseMessageToJSON(json: any): PreBookResponseMessage {
    return PreBookResponseMessageToJSONTyped(json, false);
}

export function PreBookResponseMessageToJSONTyped(value?: PreBookResponseMessage | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'status': PreBookResponseStatusToJSON(value['status']),
        'message': value['message'],
    };
}

